import { connect } from 'react-redux';

import SelectDate from './SelectDate';

export default connect((state) => ({
  isMobile: state.Device.isMobile,
}))(SelectDate);
